import {
  MasterArtworkNumberActionType,
  MasterArtworkNumberActionTypes,
  MasterArtworkNumberState,
} from "./data.type";
import { MasterArtworkCollectionActionTypes } from "../collections/data.type";

const initialState: MasterArtworkNumberState = {
  id: null,
  code: "",
  artwork_name: null,
  collection: null,
  file_name: null,
  launch_date: "",
  requestId: "",
  requestStatus: null,
  requestDateFrom: "",
  requestDateTo: "",
  requestor: "",
  requestHistory: null,
  submitComment: "",
  approveComment: "",
  rejectComment: "",
  rejectReason: null,
  hasUnsavedChanges: false,
  isValid: null,
  isReadOnly: false,
};

function reducer(
  state: MasterArtworkNumberState,
  action: MasterArtworkNumberActionType,
): MasterArtworkNumberState {
  switch (action.type) {
    case MasterArtworkNumberActionTypes.SET_ARTWORK_NUMBER:
      // @ts-ignore
      return action.payload;

    case MasterArtworkNumberActionTypes.SET_CODE:
      return {
        ...state,
        code: action.payload.code ?? "",
      };
    case MasterArtworkNumberActionTypes.SET_ARTWORK_NAME:
      return {
        ...state,
        artwork_name: action.payload.artwork_name ?? null,
      };
    case MasterArtworkNumberActionTypes.SET_FILE_NAME:
      return {
        ...state,
        file_name: action.payload.file_name ?? null,
      };
    case MasterArtworkNumberActionTypes.SET_STATUS:
      return {
        ...state,
        status: action.payload.status ?? "",
      };
    case MasterArtworkNumberActionTypes.SET_COMMENT:
      return {
        ...state,
        comment: action.payload.comment ?? "",
      };
    case MasterArtworkNumberActionTypes.SET_ID:
      return {
        ...state,
        id: action.payload.id ?? "",
      };

    case MasterArtworkNumberActionTypes.SET_COLLECTION:
      return {
        ...state,
        collection: action.payload.collection ?? null,
      };

    case MasterArtworkNumberActionTypes.SET_REQUEST_STATUS:
      return {
        ...state,
        requestStatus: action.payload.requestStatus || null,
      };
     
    case MasterArtworkNumberActionTypes.SET_LAUNCH_DATE:
      return {
        ...state,
        launch_date: action.payload.launch_date ?? "",
      };  

    case MasterArtworkNumberActionTypes.SET_SUBMIT_COMMENT:
      return {
        ...state,
        submitComment: action.payload.submitComment ?? "",
      };

    case MasterArtworkNumberActionTypes.SET_APPROVE_COMMENT:
      return {
        ...state,
        approveComment: action.payload.approveComment ?? "",
      };

    case MasterArtworkNumberActionTypes.SET_REJECT_COMMENT:
      return {
        ...state,
        rejectComment: action.payload.rejectComment ?? "",
      };

    case MasterArtworkNumberActionTypes.SET_REJECT_REASON:
      return {
        ...state,
        rejectReason: action.payload.rejectReason ?? null,
      };
    case MasterArtworkNumberActionTypes.RESET_STATE:
      // @ts-ignore
      return initialState;
    case MasterArtworkNumberActionTypes.SET_IS_VALID:
      return {
        ...state,
        isValid: action.payload.isValid || null,
      };

    case MasterArtworkNumberActionTypes.SET_UNSAVED_CHANGES:
      return {
        ...state,
        hasUnsavedChanges: action.payload.hasUnsavedChanges || false,
      };

    case MasterArtworkNumberActionTypes.SET_IS_READ_ONLY:
      return {
        ...state,
        isReadOnly: action.payload.isReadOnly ?? false,
      };

    default:
      return state;
  }
}

export const isStateEqualToInitialState = (state: MasterArtworkNumberState): boolean => {
  return Object.keys(initialState).every(
    (key) =>
      initialState[key as keyof MasterArtworkNumberState] ===
      state[key as keyof MasterArtworkNumberState],
  );
};

export const MasterArtworkNumberReducer = { initialState, reducer };
